import FLAG from 'config/flag.singleton';
import { isEnvJest, isEnvProd } from 'utils/env/determine.util';

const SCAN = {};

const IS_PROD = isEnvProd();
const IS_JEST = isEnvJest();
const OPTIONS = FLAG.reactScanOptions;

SCAN.init = async () => {
  SCAN.isProd = IS_PROD;
  SCAN.isJest = IS_JEST;
  SCAN.options = OPTIONS;

  if (IS_PROD || IS_JEST || !OPTIONS) {
    Object.freeze(SCAN);
    return;
  }

  // NOTE: replacing static import with async one fixes Jest complaining about MJS modules being imported
  const promise = import('react-scan');
  const module = await promise;

  const { scan, getOptions, getReport } = module;

  SCAN.module = module;
  SCAN.scan = scan;
  SCAN.getOptions = getOptions;
  SCAN.getReport = getReport;

  Object.freeze(SCAN);

  // example of some of the options
  // enabled: true, report: true, log: true, clearLog: true, playSound: true,
  // renderCountThreshold: 9, alwaysShowLabels: true, runInProduction: false,
  scan(OPTIONS);

  return module;
};

export default SCAN;
